import axios from "axios";
import i18next from "i18next";
import * as url from "./url_helper";
let tokenPrefix = "Bearer ";

if (custom_loader_count === undefined) var custom_loader_count = 0;

export const respStatus = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  NOT_AUTHORISED: "You are not authorised.",
};

const userAgent = navigator.userAgent.toLowerCase();
const isMobile = /android|iphone|ipad|ipod/i.test(userAgent);
const isWebView = userAgent.includes('wv');

const handelLogout = () => {
  if (isMobile) {
    if (isWebView) {
      window.location.href = document.referrer;
    } else {
      window.close();
    }
  } else {
    window.close();
  }
};

// Register Method
const base_url = window.location.origin;
const axiosApi = axios.create({
  baseURL:
    process.env.REACT_APP_ENABLE_LOCAL_API == 1
      ? process.env.REACT_APP_API_URL
      : base_url,
});
// const token = tokenPrefix + localStorage.getItem('master_token');
// axiosApi.defaults.headers.common["Authorization"] = token;

axiosApi.interceptors.request.use((config) => {
  let common_request_data = {
    [url.LOBBY_KEY]: process.env.REACT_APP_LOBBY,
    [url.LOBBY_MOB_PERM]: 'new_tg_lob_mob_status',
    [url.LOBBY_WEB_PERM]: 'new_tg_lob_web_status',
    deviceType: localStorage.getItem('deviceType'),
    [url.LOBBY_VERSION_KEY]: process.env.REACT_APP_LOBBY_VERSION
  };
  if (config.method === 'get') {
    config.params = {
      ...config.params,
      common_request_data: common_request_data,
    };
  } else {
    if (config.data instanceof Array) {
      config.data = {
        data: config.data,
        common_request_data: common_request_data,
      };
    } else if (config.data == null) {
      config.data = {
        common_request_data: common_request_data,
      };
    } else {
      config.data = {
        ...config.data,
        common_request_data: common_request_data,
      };
    }
  }

  return config;
}, (error) => {
  console.error('axiosApi.interceptors.request', error);
  return Promise.reject(error);
});

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);
const makeAjax = (
  extension,
  data,
  micro_service = url.TOGEL_MS_EXT,
  header = {}
) => {

  if (extension === url.PLAYER_API.addUserSession) {
    localStorage.removeItem(url.TOKEN_KEY);
  }


  startLoader(extension);
  let token = tokenPrefix + localStorage.getItem(url.TOKEN_KEY);
  if ((extension !== url.PLAYER_API.fetchLoader && extension !== url.PLAYER_API.addUserSession && !token)) {
    return;
  }
  axiosApi.defaults.headers.common["Authorization"] = token;
  let end_url =
    url.API_PREFIX + micro_service + url.APPLICATION_EXT + extension;
  if (process.env.REACT_APP_ENABLE_LOCAL_API == 2) {
    end_url = micro_service + url.APPLICATION_EXT + extension;
  }
  if (process.env.REACT_APP_LOCAL_EXCEPTION) {
    let exceptional_ms = process.env.REACT_APP_LOCAL_EXCEPTION.split(",");
    if (exceptional_ms.includes(micro_service)) {
      axiosApi.defaults.baseURL = 'http://127.0.0.1';
      end_url = url.API_PREFIX + micro_service + url.APPLICATION_EXT + extension;
    } else {
      axiosApi.defaults.baseURL = (process.env.REACT_APP_ENABLE_LOCAL_API == 1) ? process.env.REACT_APP_API_URL : base_url;
    }
  }
  if (!header['headers'])
    header['headers'] = {}
  header['headers'][url.LOBBY_KEY] = process.env.REACT_APP_LOBBY;
  header['headers'][url.LOBBY_MOB_PERM] = "new_tg_lob_mob_status";
  header['headers'][url.LOBBY_WEB_PERM] = "new_tg_lob_web_status";
  header['headers']["deviceType"] = localStorage.getItem('deviceType');
  header['headers'][url.LOBBY_VERSION_KEY] = process.env.REACT_APP_LOBBY_VERSION;
  return axiosApi
    .post(end_url, data, header)
    .then((response) => {
      if (response.status >= 200 || response.status <= 299) {
        if (response.data.status == "ERROR") {
          if ((response.data.code == "invalid_token_error" || response.data.code == "contact_to_customer_err") && extension != url.PLAYER_API.verifyLogin) {

            localStorage.removeItem(url.TOKEN_KEY);
            localStorage.removeItem("partner_token");
            if (isWebView) {
              handelLogout();
            }
            else {
              window.location.href = base_url + "/logout";
            }
          }
          if (response.data.code === "page_refresh") {
            window.location.reload()
          }
        }
        stopLoader(extension);
        return response.data;
      }
      stopLoader(extension);
      return { status: "ERROR", data: null };
    })
    .catch((err) => {
      stopLoader(extension);
      catchAxioExc(err);
      return { status: "ERROR", data: null, messages: generateCatchMsg(err) };
    });
};


const startLoader = (extension) => {
  if (!url.EXCLUDE_LOADER.includes(extension)) {
    if (custom_loader_count == 0) {
      let element = document.getElementById("ajax-loader");
      if (element && element.classList)
        element.classList.remove("hideMe");
    }
    custom_loader_count++;
  }
};

const stopLoader = (extension) => {
  if (!url.EXCLUDE_LOADER.includes(extension)) {
    if (custom_loader_count != 0) custom_loader_count--;
    if (custom_loader_count == 0) {
      let element = document.getElementById("ajax-loader");
      if (element && element.classList)
        element.classList.add("hideMe");
    }
  }
};

const generateCatchMsg = (err) => {
  let message = "no message";
  if (err.response && err.response.status) {
    switch (err.response.status) {
      case 404:
        message = "Sorry! the API you are looking for could not be found";
        break;
      case 500:
        message =
          "Sorry! something went wrong, please contact our support team";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      default:
        message = "unknown status code" + err.response.status;
        break;
    }
    return message;
  }
};

const catchAxioExc = (err) => {
  var message = generateCatchMsg(err);
  showMessage(message, "error");
};

const showMessage = (data, toastType, title) => {
  let message = data;
  if (typeof data === 'string') {
    message = data;
  }
  else if (typeof data?.messages === 'string') {
    message = data.messages;
  }
  else if (Array.isArray(data?.messages)) {
    message = data.messages[0];
  }
  else if (data?.messages !== null && typeof data?.messages === 'object') {
    message = JSON.stringify(data.messages);
  }
  else if (typeof data !== 'string') {
    message = JSON.stringify(data);
  }
  // if (!toastType) {
  //   toastType = data.status == "SUCCESS" ? "SUCCESS" : "error";
  // }
  if (!title) title = camelCase(data.status);
  if (data.req_id && data.status !== 'SUCCESS') {
    title = title + ' (' + data.req_id + ')';
  }
  message = typeof message === "string" ? i18next.t(message) : i18next.t(message);

  toastMessage(message, title);
  if (data.code === "you_ve_been_logged_out_successfully" || data.code === "invalid_token_error") {
    setTimeout(() => {
      handelLogout();
    }, 2000)
  }
};

const toastMessage = (message, heading = "I-Error") => {
  document.getElementById("commonToaster").style.display = "flex";
  document.getElementById("commonToasterHeading").innerHTML = heading;
  document.getElementById("commonToasterBody").innerHTML = message;
};

const camelCase = (message) => {
  return message.charAt(0).toUpperCase() + message.slice(1);
};
const matchValidateVersi = (gameType, dataBet, fastBet = false) => {
  if (gameType == "4d3d2d") {
    if (pregMatchValidation("betMultiNum2", dataBet) == 1) {
      return `format_input`;
    }
  } else if (gameType == "2dposisiDepan") {
    let posisiArr = [];
    let multidatabets = [];
    if (dataBet) {
      multidatabets.push(dataBet);
      posisiArr.push("depan");
    }

    if (multidatabets.length == 0) {
      return `format_input`;
    }

    for (let keybet = 0; keybet < multidatabets.length; keybet++) {
      let multidatabet = multidatabets[keybet];
      if (pregMatchValidation("bet2DigitMultiNum2", multidatabet) == 1) {
        return `${posisiArr[keybet]}`;
      }
    }
  } else if (gameType == "2dposisiTengah") {
    let posisiArr = [];
    let multidatabets = [];

    if (dataBet) {
      multidatabets.push(dataBet);
      posisiArr.push("tengah");
    }

    if (multidatabets.length == 0) {
      return `format_input`;
    }

    for (let keybet = 0; keybet < multidatabets.length; keybet++) {
      let multidatabet = multidatabets[keybet];
      if (pregMatchValidation("bet2DigitMultiNum2", multidatabet) == 1) {
        return `${posisiArr[keybet]}`;
      }
    }
  } else if (gameType == "3dposisi") {
    let posisiArr = [];
    let multidatabets = [];
    if (dataBet) {
      multidatabets.push(dataBet);
      posisiArr.push("depan");
    }

    if (multidatabets.length == 0) {
      return `format_input`;
    }

    for (let keybet = 0; keybet < multidatabets.length; keybet++) {
      let multidatabet = multidatabets[keybet];
      if (pregMatchValidation("bet3DigitMultiNum2", multidatabet) == 1) {
        return `${posisiArr[keybet]}`;
      }
    }
  } else if (gameType == "bbcampuran") {
    let posisiArr = [];
    let multidatabets = [];
    if (dataBet.databet_depan) {
      multidatabets.push(dataBet.databet_depan);
      posisiArr.push("Depan");
    }
    if (dataBet.databet_tengah) {
      multidatabets.push(dataBet.databet_tengah);
      posisiArr.push("tengah");
    }
    if (dataBet.databet_belakang) {
      multidatabets.push(dataBet.databet_belakang);
      posisiArr.push("Belakang");
    }

    if (multidatabets.length == 0) {
      return `format_input`;
    }

    for (let keybet = 0; keybet < multidatabets.length; keybet++) {
      let multidatabet = multidatabets[keybet];
      if (pregMatchValidation("betMultiNum2", multidatabet) == 1) {
        return `format_input`;
      }
    }
  } else if (gameType == "polatarung") {
    let posisiArr = [];
    let multidatabets = [];
    if (dataBet.databet_4d) {
      multidatabets.push(dataBet.databet_4d);
      posisiArr.push("Belakang");
    }
    if (dataBet.databet_3d_belakang) {
      multidatabets.push(dataBet.databet_3d_belakang);
      posisiArr.push("Belakang");
    }
    if (dataBet.databet_3d_belakang) {
      multidatabets.push(dataBet.databet_3d_belakang);
      posisiArr.push("Belakang");
    }
    if (dataBet.databet_3d_depan) {
      multidatabets.push(dataBet.databet_3d_depan);
      posisiArr.push("Depan");
    }
    if (dataBet.databet_2d_depan) {
      multidatabets.push(dataBet.databet_2d_depan);
      posisiArr.push("Depan");
    }
    if (dataBet.databet_2d_tengah) {
      multidatabets.push(dataBet.databet_2d_tengah);
      posisiArr.push("Tengah");
    }

    if (multidatabets.length == 0) {
      return `format_input`;
    }

    for (let keybet = 0; keybet < multidatabets.length; keybet++) {
      let multidatabet = multidatabets[keybet];
      if (pregMatchValidation("betMultiNum2", multidatabet) == 1) {
        return `format_input`;
      }
    }
  } else {
    let length;
    if (gameType == "colokbebas" || gameType == "colokbebas2d" || gameType == "coloknaga") {
      if (gameType == "colokbebas") {
        length = 1;
      } else if (gameType == "colokbebas2d") {
        length = 2;
      } else if (gameType == "coloknaga") {
        length = 3;
      }

      if (pregMatchValidation("bet" + length + "DigitMultiNum2", dataBet) === 1) {
        return "format_input";
      }
    } else if (gameType == "colokjitu") {
      let posisiArr = [];
      let multidatabets = [];

      if (dataBet.databet_as) {
        multidatabets.push(dataBet.databet_as);
        posisiArr.push("as");
      }

      if (dataBet.databet_kop) {
        multidatabets.push(dataBet.databet_kop);
        posisiArr.push("kop");
      }

      if (dataBet.databet_kepala) {
        multidatabets.push(dataBet.databet_kepala);
        posisiArr.push("kepala");
      }

      if (dataBet.databet_ekor) {
        multidatabets.push(dataBet.databet_ekor);
        posisiArr.push("ekor");
      }

      if (multidatabets.length == 0) {
        return `format_input`;
      }

      for (let keybet = 0; keybet < multidatabets.length; keybet++) {
        let multidatabet = multidatabets[keybet];
        if (pregMatchValidation("bet1DigitMultiNum2", multidatabet) == 1) {
          return `${posisiArr[keybet]}`;
        }
      }
    } else if (gameType == "tengahtepi") {
      let posisiArr = [];
      let multidatabets = [];
      if (dataBet.databet_tepi) {
        multidatabets.push(dataBet.databet_tepi);
        posisiArr.push("tepi");
      }

      if (dataBet.databet_tengah) {
        multidatabets.push(dataBet.databet_tengah);
        posisiArr.push("tengah");
      }

      if (multidatabets.length == 0) {
        return `format_input`;
      }

      for (let keybet = 0; keybet < multidatabets.length; keybet++) {
        let multidatabet = multidatabets[keybet];
        if (pregMatchValidation("numOnly", multidatabet) == 1) {
          return `${posisiArr[keybet]}`;
        }
      }
    } else if (gameType == "dasar" && fastBet) {
      let posisiArr = [];
      let multidatabets = [];

      if (dataBet.databet_ganjil) {
        multidatabets.push(dataBet.databet_ganjil);
        posisiArr.push("ganjil");
      }

      if (dataBet.databet_genap) {
        multidatabets.push(dataBet.databet_genap);
        posisiArr.push("genap");
      }

      if (dataBet.databet_besar) {
        multidatabets.push(dataBet.databet_besar);
        posisiArr.push("besar");
      }

      if (dataBet.databet_kecil) {
        multidatabets.push(dataBet.databet_kecil);
        posisiArr.push("kecil");
      }

      if (multidatabets.length == 0) {
        return `format_input`;
      }

      for (let keybet = 0; keybet < multidatabets.length; keybet++) {
        let multidatabet = multidatabets[keybet];
        if (pregMatchValidation("numOnly", multidatabet) == 1) {
          return `${posisiArr[keybet]}`;
        }
      }
    } else if (gameType == "dasar") {
      if (pregMatchValidation("betMultiAlphaNum2", dataBet) == 1) {
        return `format_input`;
      }
    } else if (gameType == "5050") {
      let multidatabets = [];
      let posisiArr = [];
      if (dataBet.databet_as) {
        multidatabets.push(dataBet.databet_as);
        posisiArr.push("as");
      }

      if (dataBet.databet_kop) {
        multidatabets.push(dataBet.databet_kop);
        posisiArr.push("kop");
      }

      if (dataBet.databet_kepala) {
        multidatabets.push(dataBet.databet_kepala);
        posisiArr.push("kepala");
      }

      if (dataBet.databet_ekor) {
        multidatabets.push(dataBet.databet_ekor);
        posisiArr.push("ekor");
      }

      if (multidatabets.length == 0) {
        return `format_input`;
      }

      for (let keybet = 0; keybet < multidatabets.length; keybet++) {
        let multidatabet = multidatabets[keybet];
        if (pregMatchValidation("betMultiAlphaNum2", multidatabet) == 1) {
          return `format_input`;
        }
      }
    } else if (gameType == "50502d") {
      if (pregMatchValidation("betMultiAlphaNum2", dataBet.databet) == 1) {
        return `format_input`;
      }
    } else if (gameType == "shio") {
      if ((pregMatchValidation("betShioMultiWap", dataBet.toLowerCase()) === 1 && fastBet) || !dataBet.includes('#')) {
        return `format_input`;
      }
    } else if (gameType == "silanghomo") {
      let posisiArr = [];
      let multidatabets = [];

      if (dataBet.databet_silang_depan) {
        multidatabets.push(dataBet.databet_silang_depan);
        posisiArr.push("Silang-Depan");
      }

      if (dataBet.databet_silang_tengah) {
        multidatabets.push(dataBet.databet_silang_tengah);
        posisiArr.push("Silang-tengah");
      }

      if (dataBet.databet_silang_belakang) {
        multidatabets.push(dataBet.databet_silang_belakang);
        posisiArr.push("Silang-Belakang");
      }

      if (dataBet.databet_homo_depan) {
        multidatabets.push(dataBet.databet_homo_depan);
        posisiArr.push("Homo-Depan");
      }
      if (dataBet.databet_homo_tengah) {
        multidatabets.push(dataBet.databet_homo_tengah);
        posisiArr.push("Homo-Tengah");
      }
      if (dataBet.databet_homo_belakang) {
        multidatabets.push(dataBet.databet_homo_belakang);
        posisiArr.push("Homo-Belakang");
      }

      if (multidatabets.length == 0) {
        return `format_input`;
      }

      for (let keybet = 0; keybet < multidatabets.length; keybet++) {
        let multidatabet = multidatabets[keybet];
        if (pregMatchValidation("numOnly", multidatabet) == 1) {
          return `${posisiArr[keybet].replace('-', ' ')}`;
        }
      }
    } else if (gameType == "kembangkempis") {
      let posisiArr = [];
      let multidatabets = [];

      if (dataBet.databet_kembang_depan) {
        multidatabets.push(dataBet.databet_kembang_depan);
        posisiArr.push("Kembang-Depan");
      }
      if (dataBet.databet_kembang_tengah) {
        multidatabets.push(dataBet.databet_kembang_tengah);
        posisiArr.push("Kembang-tengah");
      }
      if (dataBet.databet_kembang_belakang) {
        multidatabets.push(dataBet.databet_kembang_belakang);
        posisiArr.push("Kembang-Belakang");
      }
      if (dataBet.databet_kempis_depan) {
        multidatabets.push(dataBet.databet_kempis_depan);
        posisiArr.push("Kempis-Depan");
      }
      if (dataBet.databet_kempis_tengah) {
        multidatabets.push(dataBet.databet_kempis_tengah);
        posisiArr.push("Kempis-Tengah");
      }
      if (dataBet.databet_kempis_belakang) {
        multidatabets.push(dataBet.databet_kempis_belakang);
        posisiArr.push("Kempis-Belakang");
      }
      if (dataBet.databet_kembar_depan) {
        multidatabets.push(dataBet.databet_kembar_depan);
        posisiArr.push("Kembar-Depan");
      }
      if (dataBet.databet_kembar_tengah) {
        multidatabets.push(dataBet.databet_kembar_tengah);
        posisiArr.push("Kembar-Tengah");
      }
      if (dataBet.databet_kembar_belakang) {
        multidatabets.push(dataBet.databet_kembar_belakang);
        posisiArr.push("Kembar-Belakang");
      }

      if (multidatabets.length == 0) {
        return `format_input`;
      }

      for (let keybet = 0; keybet < multidatabets.length; keybet++) {
        let multidatabet = multidatabets[keybet];
        if (pregMatchValidation("numOnly", multidatabet) == 1) {
          return `${posisiArr[keybet].replace('-', ' ')}`;
        }
      }
    }
  }
};


const pregMatchValidation = (stmt, val) => {
  const patterns = {
    alphaNum: /^(?=[a-z]*[0-9])(?=[0-9]*[a-z])([a-z0-9]+)$/,
    dateValid: /^([0-9]{2})-([0-9]{2})-([0-9]{4})$/,
    alphaOnly: /^[a-z]+$/,
    numOnly: /^[0-9]+$/,
    alphaSpace: /^[a-z]+( [a-z]+)*$/i,
    num4Digit: /^[0-9]{4}$/,
    num3Digit: /^[0-9]{3}$/,
    num2Digit: /^[0-9]{2}$/,
    num1Digit: /^[0-9]{1}$/,
    betMultiNum: /^[0-9]{2,4}(?:[*][0-9]{2,4})*#[0-9]+$/,
    betMultiNum2: /^[0-9]{2,4}(?:[*][0-9]{2,4})*#[0-9]+(?:\+[0-9]{2,4}(?:[*][0-9]{2,4})*#[0-9]+)*$/,
    betSingleNum2: /^[0-9]{2,6}#[0-9]+$/,
    betMultiAlphaNum: /^[a-z0-9]{1,2}(?:[*][a-z0-9]{1,2})*#[0-9]+$/,
    betMultiAlphaNum2: /^[a-z0-9]{1,2}(?:[*][a-z0-9]{1,2})*#[0-9]+(?:\+[a-z0-9]{1,2}(?:[*][a-z0-9]{1,2})*#[0-9]+)*$/,
    betMax2DigitMultiNum: /^[0-9]{1,2}(?:[*][0-9]{1,2})*#[0-9]+$/,
    betMax2DigitMultiNum2: /^[0-9]{1,2}(?:[*][0-9]{1,2})*#[0-9]+(?:\+[0-9]{1,2}(?:[*][0-9]{1,2})*#[0-9]+)*$/,
    bet3DigitMultiNum2: /^[0-9]{3}(?:[*][0-9]{3})*#[0-9]+(?:\+[0-9]{3}(?:[*][0-9]{3})*#[0-9]+)*$/,
    bet2DigitMultiNum2: /^[0-9]{2}(?:[*][0-9]{2})*#[0-9]+(?:\+[0-9]{2}(?:[*][0-9]{2})*#[0-9]+)*$/,
    bet1DigitMultiNum2: /^[0-9](?:[*][0-9])*#[0-9]+(?:\+[0-9](?:[*][0-9])*#[0-9]+)*$/,
    betShioMultiWap: /^(tikus|kerbau|harimau|kelinci|naga|ular|kuda|kambing|monyet|ayam|anjing|babi|[0-9]{1,2})(?:([*](tikus|kerbau|harimau|kelinci|naga|ular|kuda|kambing|monyet|ayam|anjing|babi|[0-9]{1,2}))*)#[0-9]+(?:([+](tikus|kerbau|harimau|kelinci|naga|ular|kuda|kambing|monyet|ayam|anjing|babi|[0-9]{1,2}))+(?:([*](tikus|kerbau|harimau|kelinci|naga|ular|kuda|kambing|monyet|ayam|anjing|babi|[0-9]{1,2}))*)+#[0-9]+)*$/,
    mobileUrl: /^([m]{1}|[m][0-9]{1,2})[.]{1}$/,
    regexBB: /^[0-9]+(?:(\s*\.\s*[0-9]+)*)\s*\s*bb\s*\s*[0-9]+\s*\s*\/\s*\s*[0-9]+\s*\s*\/\s*\s*[0-9]+$/i,
    regexQuickBet: /^[0-9]{4}(?:(\s*\.\s*[0-9]{4})*)\s*\=\s*[0-9]+\s*\s*\/\s*\s*[0-9]+\s*\s*\/\s*\s*[0-9]+$/i,
    regexNomor1: /^[0-9]{2,4}(?:(\s*[.*]\s*[0-9]{2,4})*)\s*[=]\s*[0-9]+(?:(\s*[.+]\s*[0-9]{2,4}(?:(\s*[.*]\s*[0-9]{2,4})*)\s*[=]\s*[0-9]+)*)$/i,
    regexNomorErr1: /^[0-9]+(?:(\s*[.*]\s*[0-9]+)*)\s*[=]\s*[0-9]+(?:(\s*[.+]\s*[0-9]+(?:(\s*[.*]\s*[0-9]+)*)\s*[=]\s*[0-9]+)*)$/i,
    regexNomor2: /^([0-9]{2,4}(?:(\s*\.\s*[0-9]{2,4})*)|\s*\(\s*[0-9]{2,4}(?:(\s*\,\s*[0-9]{2,4})*)\s*\)\s*)\s*[=]\s*[0-9]+(?:(\s*\.\s*([0-9]{2,4}(?:(\s*\.\s*[0-9]{2,4})*)|\s*\(\s*[0-9]{2,4}(?:(\s*\,\s*[0-9]{2,4})*)\s*\)\s*)\s*[=]\s*[0-9]+)*)$/i,
    regexColokBebas: /^(cl|cb|colok)\s*\s*[0-9]{1}(?:(\s*[.*]\s*[0-9]{1})*)\s*[=]\s*[0-9]+(?:(\s*[.+]\s*[0-9]{1}(?:(\s*[.*]\s*[0-9]{1})*)\s*[=]\s*[0-9]+)*)$/i,
    regexColokBebas2D: /^(cm|colokmacau|cp|om|mako)\s*\s*[0-9]{2}(?:(\s*[.*]\s*[0-9]{2})*)\s*[=]\s*[0-9]+(?:(\s*[.+]\s*[0-9]{2}(?:(\s*[.*]\s*[0-9]{2})*)\s*[=]\s*[0-9]+)*)$/i,
    regexColokBebas2D_2: /^[0-9]{1}\s*\+\s*[0-9]{1}(?:(\s*\.\s*[0-9]{1}\s*\+\s*[0-9]{1})*)\s*[=]\s*[0-9]+$/i,
    regexColokNaga: /^(cn|coloknaga)\s*\s*[0-9]{3}(?:(\s*[.*]\s*[0-9]{3})*)\s*[=]\s*[0-9]+(?:(\s*[.+]\s*[0-9]{3}(?:(\s*[.*]\s*[0-9]{3})*)\s*[=]\s*[0-9]+)*)$/i,
    regexColokNaga_2: /^[0-9]{1}\s*\+\s*[0-9]{1}\s*\+\s*[0-9]{1}(?:(\s*\.\s*[0-9]{1}\s*\+\s*[0-9]{1}\s*\+\s*[0-9]{1})*)\s*[=]\s*[0-9]+$/i,
    regexColokJitu: /^(cja|cjk|cjkp|cje)\s*\s*[0-9]{1}(?:(\s*[.*]\s*[0-9]{1})*)\s*[=]\s*[0-9]+(?:(\s*[.+]\s*[0-9]{1}(?:(\s*[.*]\s*[0-9]{1})*)\s*[=]\s*[0-9]+)*)$/i,
    regexTengahTepi: /^(tengah|tepi)\s*\s*(?:(\s*[.*]\s*(tengah|tepi)\s*\s*)*)\s*[=]\s*[0-9]+(?:(\s*[.+]\s*(tengah|tepi)\s*\s*(?:(\s*[.*]\s*(tengah|tepi)\s*\s*)*)\s*[=]\s*[0-9]+)*)$/i,
    regex5050: /^(askecil\b|askc\b|ask\b|akecil\b|akc\b|ak\b|asbesar\b|asbs\b|asb\b|abesar\b|abs\b|ab\b|asganjil\b|asgj\b|asgl\b|aganjil\b|agj\b|agl\b|asgenap\b|asgn\b|asgp\b|agenap\b|agn\b|agp\b|kopkecil\b|kopkc\b|kopk\b|kkecil\b|kkc\b|kk\b|kopbesar\b|kopbs\b|kopb\b|kbesar\b|kbs\b|kb\b|kopganjil\b|kopgj\b|kopgl\b|kganjil\b|kgj\b|kgl\b|kopgenap\b|kopgn\b|kopgp\b|kgenap\b|kgn\b|kgp\b|kepalakecil\b|kepalakc\b|kepalak\b|kpkecil\b|kpkc\b|kpk\b|kepalabesar\b|kepalabs\b|kepalab\b|kpbesar\b|kpbs\b|kpb\b|kepalaganjil\b|kepalagj\b|kepalagl\b|kpganjil\b|kpgj\b|kpgl\b|kepalagenap\b|kepalagn\b|kepalagp\b|kpgenap\b|kpgn\b|kpgp\b|ekorkecil\b|ekorkc\b|ekork\b|ekecil\b|ekc\b|ek\b|ekorbesar\b|ekorbs\b|ekorb\b|ebesar\b|ebs\b|eb\b|ekorganjil\b|ekorgj\b|ekorgl\b|eganjil\b|egj\b|egl\b|ekorgenap\b|ekorgn\b|ekorgp\b|egenap\b|egn\b|egp\b)(?:(\s*\.\s*(askecil\b|askc\b|ask\b|akecil\b|akc\b|ak\b|asbesar\b|asbs\b|asb\b|abesar\b|abs\b|ab\b|asganjil\b|asgj\b|asgl\b|aganjil\b|agj\b|agl\b|asgenap\b|asgn\b|asgp\b|agenap\b|agn\b|agp\b|kopkecil\b|kopkc\b|kopk\b|kkecil\b|kkc\b|kk\b|kopbesar\b|kopbs\b|kopb\b|kbesar\b|kbs\b|kb\b|kopganjil\b|kopgj\b|kopgl\b|kganjil\b|kgj\b|kgl\b|kopgenap\b|kopgn\b|kopgp\b|kgenap\b|kgn\b|kgp\b|kepalakecil\b|kepalakc\b|kepalak\b|kpkecil\b|kpkc\b|kpk\b|kepalabesar\b|kepalabs\b|kepalab\b|kpbesar\b|kpbs\b|kpb\b|kepalaganjil\b|kepalagj\b|kepalagl\b|kpganjil\b|kpgj\b|kpgl\b|kepalagenap\b|kepalagn\b|kepalagp\b|kpgenap\b|kpgn\b|kpgp\b|ekorkecil\b|ekorkc\b|ekork\b|ekecil\b|ekc\b|ek\b|ekorbesar\b|ekorbs\b|ekorb\b|ebesar\b|ebs\b|eb\b|ekorganjil\b|ekorgj\b|ekorgl\b|eganjil\b|egj\b|egl\b|ekorgenap\b|ekorgn\b|ekorgp\b|egenap\b|egn\b|egp\b))*)\s*[=]\s*[0-9]+(?:(\s*[.+]\s*(askecil\b|askc\b|ask\b|akecil\b|akc\b|ak\b|asbesar\b|asbs\b|asb\b|abesar\b|abs\b|ab\b|asganjil\b|asgj\b|asgl\b|aganjil\b|agj\b|agl\b|asgenap\b|asgn\b|asgp\b|agenap\b|agn\b|agp\b|kopkecil\b|kopkc\b|kopk\b|kkecil\b|kkc\b|kk\b|kopbesar\b|kopbs\b|kopb\b|kbesar\b|kbs\b|kb\b|kopganjil\b|kopgj\b|kopgl\b|kganjil\b|kgj\b|kgl\b|kopgenap\b|kopgn\b|kopgp\b|kgenap\b|kgn\b|kgp\b|kepalakecil\b|kepalakc\b|kepalak\b|kpkecil\b|kpkc\b|kpk\b|kepalabesar\b|kepalabs\b|kepalab\b|kpbesar\b|kpbs\b|kpb\b|kepalaganjil\b|kepalagj\b|kepalagl\b|kpganjil\b|kpgj\b|kpgl\b|kepalagenap\b|kepalagn\b|kepalagp\b|kpgenap\b|kpgn\b|kpgp\b|ekorkecil\b|ekorkc\b|ekork\b|ekecil\b|ekc\b|ek\b|ekorbesar\b|ekorbs\b|ekorb\b|ebesar\b|ebs\b|eb\b|ekorganjil\b|ekorgj\b|ekorgl\b|eganjil\b|egj\b|egl\b|ekorgenap\b|ekorgn\b|ekorgp\b|egenap\b|egn\b|egp\b)(?:(\s*\.\s*(askecil\b|askc\b|ask\b|akecil\b|akc\b|ak\b|asbesar\b|asbs\b|asb\b|abesar\b|abs\b|ab\b|asganjil\b|asgj\b|asgl\b|aganjil\b|agj\b|agl\b|asgenap\b|asgn\b|asgp\b|agenap\b|agn\b|agp\b|kopkecil\b|kopkc\b|kopk\b|kkecil\b|kkc\b|kk\b|kopbesar\b|kopbs\b|kopb\b|kbesar\b|kbs\b|kb\b|kopganjil\b|kopgj\b|kopgl\b|kganjil\b|kgj\b|kgl\b|kopgenap\b|kopgn\b|kopgp\b|kgenap\b|kgn\b|kgp\b|kepalakecil\b|kepalakc\b|kepalak\b|kpkecil\b|kpkc\b|kpk\b|kepalabesar\b|kepalabs\b|kepalab\b|kpbesar\b|kpbs\b|kpb\b|kepalaganjil\b|kepalagj\b|kepalagl\b|kpganjil\b|kpgj\b|kpgl\b|kepalagenap\b|kepalagn\b|kepalagp\b|kpgenap\b|kpgn\b|kpgp\b|ekorkecil\b|ekorkc\b|ekork\b|ekecil\b|ekc\b|ek\b|ekorbesar\b|ekorbs\b|ekorb\b|ebesar\b|ebs\b|eb\b|ekorganjil\b|ekorgj\b|ekorgl\b|eganjil\b|egj\b|egl\b|ekorgenap\b|ekorgn\b|ekorgp\b|egenap\b|egn\b|egp\b))*)\s*[=]\s*[0-9]+)*)$/i,
    regex50502D: /^(kecil\b|kc\b|k\b|besar\b|bs\b|b\b|ganjil\b|gj\b|gl\b|genap\b|gn\b|gp\b)(?:(\s*[.*]\s*(kecil\b|kc\b|k\b|besar\b|bs\b|b\b|ganjil\b|gj\b|gl\b|genap\b|gn\b|gp\b))*)\s*[=]\s*[0-9]+(?:(\s*\+\s*(kecil\b|kc\b|k\b|besar\b|bs\b|b\b|ganjil\b|gj\b|gl\b|genap\b|gn\b|gp\b)(?:(\s*[.*]\s*(kecil\b|kc\b|k\b|besar\b|bs\b|b\b|ganjil\b|gj\b|gl\b|genap\b|gn\b|gp\b))*)\s*[=]\s*[0-9]+)*)$/i,
    regexShio1: /^(shio3\b|shio4\b|shio5\b|shio6\b|shio7\b|shio8\b|shio9\b|shio10\b|shio11\b|shio12\b|shio1\b|shio2\b|sio3\b|sio4\b|sio5\b|sio6\b|sio7\b|sio8\b|sio9\b|sio10\b|sio11\b|sio12\b|sio1\b|sio2\b|sh3\b|sh4\b|sh5\b|sh6\b|sh7\b|sh8\b|sh9\b|sh10\b|sh11\b|sh12\b|sh1\b|sh2\b|tikus|kerbau|harimau|kelinci|naga|ular|kuda|kambing|monyet|ayam|anjing|babi)(?:(\s*[.*]\s*(shio3\b|shio4\b|shio5\b|shio6\b|shio7\b|shio8\b|shio9\b|shio10\b|shio11\b|shio12\b|shio1\b|shio2\b|sio3\b|sio4\b|sio5\b|sio6\b|sio7\b|sio8\b|sio9\b|sio10\b|sio11\b|sio12\b|sio1\b|sio2\b|sh3\b|sh4\b|sh5\b|sh6\b|sh7\b|sh8\b|sh9\b|sh10\b|sh11\b|sh12\b|sh1\b|sh2\b|tikus|kerbau|harimau|kelinci|naga|ular|kuda|kambing|monyet|ayam|anjing|babi))*)\s*[=]\s*[0-9]+(?:(\s*\+\s*(shio3\b|shio4\b|shio5\b|shio6\b|shio7\b|shio8\b|shio9\b|shio10\b|shio11\b|shio12\b|shio1\b|shio2\b|sio3\b|sio4\b|sio5\b|sio6\b|sio7\b|sio8\b|sio9\b|sio10\b|sio11\b|sio12\b|sio1\b|sio2\b|sh3\b|sh4\b|sh5\b|sh6\b|sh7\b|sh8\b|sh9\b|sh10\b|sh11\b|sh12\b|sh1\b|sh2\b|tikus|kerbau|harimau|kelinci|naga|ular|kuda|kambing|monyet|ayam|anjing|babi)(?:(\s*[.*]\s*(shio3\b|shio4\b|shio5\b|shio6\b|shio7\b|shio8\b|shio9\b|shio10\b|shio11\b|shio12\b|shio1\b|shio2\b|sio3\b|sio4\b|sio5\b|sio6\b|sio7\b|sio8\b|sio9\b|sio10\b|sio11\b|sio12\b|sio1\b|sio2\b|sh3\b|sh4\b|sh5\b|sh6\b|sh7\b|sh8\b|sh9\b|sh10\b|sh11\b|sh12\b|sh1\b|sh2\b|tikus|kerbau|harimau|kelinci|naga|ular|kuda|kambing|monyet|ayam|anjing|babi))*)\s*[=]\s*[0-9]+)*)$/i,
    regexShio2: /^(sio\s*\.\s*|sio|sh|shio)(\s*\s*[0-9]{1,2}(?:(\s*[.*]\s*[0-9]{1,2})*)|\s*\(\s*[0-9]{1,2}(?:(\s*\,\s*[0-9]{1,2})*)\s*\)\s*)\s*[=]\s*[0-9]+(?:(\s*\.\s*(\s*\s*[0-9]{1,2}(?:(\s*[.*]\s*[0-9]{1,2})*)|\s*\(\s*[0-9]{1,2}(?:(\s*\,\s*[0-9]{1,2})*)\s*\)\s*)\s*[=]\s*[0-9]+)*)$/i,
    regexRetAngka: /^ret[0-9]+\=[0-9]+$/i,
    regexRetPosisi: /^ret((ekor|kepala)[0-9]{1}|kembar)\=[0-9]+$/i,
    regexSilangHomo: /^(silang|homo)(depan|tengah|belakang)(?:(\s*[.*]\s*(silang|homo)(depan|tengah|belakang))*)\=[0-9]+$/i,
    regexKombinasi: /^(kom)(kepalaganjil|kepalagenap|kepalabesar|kepalakecil)(ekorganjil|ekorgenap|ekorbesar|ekorkecil)(?:(\s*[.*]\s*(kom)(kepalaganjil|kepalagenap|kepalabesar|kepalakecil)(ekorganjil|ekorgenap|ekorbesar|ekorkecil))*)\=[0-9]+$/i,
  };


  if (!patterns[stmt].test(val)) {
    return 1;
  } else {
    return 0;
  }
};

const arrayGuess = (val, initial) => {
  const arraygame = {
    'SGP': 'www.singaporepools.com.sg',
    'MC': 'www.magnumcambodia.com',
    'SD': 'www.sydneypoolstoday.com',
    'CN': 'www.chinapools.asia',
    'TW': 'www.taiwan-lotto.com',
    'HK': 'www.hongkongpools.com',
    'MA': 'www.macau4donline.com',
    'PR': 'www.peru-pools.com',
    'MO': 'www.mongolia-4d.com',
    'TP': 'www.taipeipools.com',
    'C4': 'www.china4dlottery.com',
    'SN': 'www.saigonpools.com',
    'OS': 'www.osakapools.com',
    'MY': 'www.malaysiapools.net',
    'SP': 'www.sg45lotto.com',
    'QN': 'www.macau-lottery.com',
    'TD': 'www.thailand4d.com',
    'JPN': 'www.japanpools.online',
    'SI': 'www.singaporepools.com.sg',
    'LS': 'www.livelaospools.com',
    'BM': 'www.burma4d.live',
    'HN': 'www.hanoi4d.net',
    'VP': 'www.vietnamtoto.com',
    'MW': 'www.mongoliawinner.com',
    'NP': 'www.nusantarapools.com',
    'GP': 'www.grabpools.com',
    'MR': 'www.myanmarresult.com',
    'KR': 'koreapools.asia',
  };


  // Check if the key exists in the object
  if (arraygame.hasOwnProperty(initial)) {
    return arraygame[initial];
  } else {
    return initial;
  }
};

const gameList = [
  {
    "game_id": 202,
    "game_code": "MC",
    "game_name": "Cambodia",
  },
  {
    "game_id": 203,
    "game_code": "SD",
    "game_name": "Sydney",
  },
  {
    "game_id": 204,
    "game_code": "CN",
    "game_name": "China",
  },
  {
    "game_id": 209,
    "game_code": "JPN",
    "game_name": "Japan"
  },
  {
    "game_id": 201,
    "game_code": "SGP",
    "game_name": "Singapore",
  },
  {
    "game_id": 212,
    "game_code": "GP",
    "game_name": "Grabpools"
  },
  {
    "game_id": 210,
    "game_code": "MW",
    "game_name": "Mongolia",
  },
  {
    "game_id": 205,
    "game_code": "TW",
    "game_name": "Taiwan",
  },
  {
    "game_id": 211,
    "game_code": "NP",
    "game_name": "Nusantara",
  },
  {
    "game_id": 206,
    "game_code": "HK",
    "game_name": "Hongkong",
  }
];

const dotNumberValidation = (value) => {
  let sanitizedValue = '';

  // Step 1: Remove all non-numeric and non-dot characters
  sanitizedValue = value.split('').filter(char => char === '.' || (char >= '0' && char <= '9')).join('');

  // Step 2: Handle leading zeros
  if (sanitizedValue.startsWith('0') && sanitizedValue.length > 1 && sanitizedValue[1] !== '.') {

    // If it starts with '0' followed by digits (e.g., '01', '001'), reduce it to a single '0'
    sanitizedValue = '0' + sanitizedValue.slice(1).replace(/^0+/, '');
  }

  // Step 3: Ensure only one dot exists and is correctly placed
  let dotIndex = sanitizedValue.indexOf('.');
  if (dotIndex !== -1) {
    let firstPart = sanitizedValue.slice(0, dotIndex + 1);
    let secondPart = sanitizedValue.slice(dotIndex + 1).replace(/\./g, ''); // Remove any extra dots after the first one
    sanitizedValue = firstPart + secondPart;
  }

  // Step 4: Ensure only one digit after the dot
  dotIndex = sanitizedValue.indexOf('.');
  if (dotIndex !== -1 && sanitizedValue.length > dotIndex + 2) {

    sanitizedValue = sanitizedValue.slice(0, dotIndex + 2);
  }

  // Step 4: Remove trailing ".0" if it exists
  if (sanitizedValue.startsWith('.')) {
    sanitizedValue = sanitizedValue.slice(0, -1); // Remove the last two characters (".0")
  }

  // Step 5: Remove trailing ".0" if it exists
  if (sanitizedValue.endsWith('.0') || sanitizedValue == '0.0') {
    sanitizedValue = sanitizedValue.slice(0, -2); // Remove the last two characters (".0")
  }

  // Step 6: Remove leading zero only if it is not before a dot
  if (sanitizedValue.startsWith('0') && sanitizedValue.length > 1) {
    // Check if the zero is before a dot (e.g., "0.1")
    if (sanitizedValue[1] !== '.') {
      let firstNonZeroIndex = sanitizedValue.search(/[^0]/);
      if (firstNonZeroIndex !== -1) {
        sanitizedValue = sanitizedValue.slice(firstNonZeroIndex);
      }
    }
  }

  return sanitizedValue;
}

const dotNumberBlurValidation = (value) => {
  let sanitizedValue = value;
  // Step 1: Remove trailing dot if it exists
  if (sanitizedValue.endsWith('.')) {
    sanitizedValue = sanitizedValue.slice(0, -1); // Remove the last character (".")
  }

  // Step 2: Remove 0 if it exists
  if (sanitizedValue == '0') {
    sanitizedValue = sanitizedValue.slice(0, -1); // Remove the last one characters ("0")
  }

  return sanitizedValue;
}

const withDotValidation = (value) => {
  let sanitizedValue = value;
  // Step 1: Remove any non-numeric characters except dots
  sanitizedValue = sanitizedValue.replace(/[^0-9]/g, "");

  // Step 2: Remove leading zero only if it is in 1st position
  if (sanitizedValue.startsWith('0')) {
    // if (sanitizedValue[1] !== '.') {
    //   let firstNonZeroIndex = sanitizedValue.search(/[^0]/);
    //   if (firstNonZeroIndex !== -1) {
    //     sanitizedValue = sanitizedValue.slice(firstNonZeroIndex);
    //   }
    // }
    sanitizedValue = sanitizedValue.slice(0, -1);
  }

  return sanitizedValue;
}

export { makeAjax, url, tokenPrefix, showMessage, camelCase, matchValidateVersi, arrayGuess, gameList, dotNumberValidation, dotNumberBlurValidation, withDotValidation, handelLogout, isWebView };
